import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ProjectDownloadFile {
  name: string;
  format: string;
  url?: string;
  content?: string;
}

@Component({
  selector: 'fun-project-documents',
  templateUrl: './project-documents.component.html',
  styleUrls: ['./project-documents.component.scss'],
})
export class ProjectDocumentsComponent {

  @Input() files: ProjectDownloadFile[] = [];
  @Output() public openFileEvent = new EventEmitter<ProjectDownloadFile>();

  openFile(file: ProjectDownloadFile) {
    this.openFileEvent.emit(file);
  }
}
